import Button from '@doordash/component-button'
import {
  Text,
  Colors,
  Inset,
  Stack,
  StackChildren,
} from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'

import * as actions from '../../../../actions'
import { DeliveryIssue } from '../../../../models/types'
import routes from '../../../../routes'
import { getCriticalDeliveryIssues } from '../../../../selectors/deliveryIssues'
import { UndecoratedLink } from '../components/styles'
import CustomerUnavailableSVG from '../images/customer-unavailable'
import t from './strings'
import { Container, ContentContainer, ImageContainer } from './styles'

type TakeoverProps = {
  getDeliveryIssuesList: (dasherId: string) => void
  criticalDeliveryIssues: DeliveryIssue[]
  dasherId: string
}

/**
 * Delivery issue splash screen that will show when a dasher has one or more
 * critical delivery issue(s). A critical delivery is defined as having a
 * priority of 1 and a status of 'unread'.
 * This is a webview that Android and iOS will show.
 * @param {TakeoverProps} props
 */
const Takeover: React.FunctionComponent<TakeoverProps> = props => {
  const { dasherId, getDeliveryIssuesList, criticalDeliveryIssues } = props

  /**
   * fetch delivery issues list
   */
  React.useEffect(() => {
    getDeliveryIssuesList(dasherId)
  }, [dasherId])

  return (
    <React.Fragment>
      <Inset>
        <Container>
          <ImageContainer>
            <CustomerUnavailableSVG />
          </ImageContainer>
          <ContentContainer>
            <StackChildren>
              <Text
                styles={Text.Styles.Bold24}
                textAlign={Text.TextAlignments.Center}
              >
                {t.titleText()}
              </Text>
              <Text color={Colors.SystemGrey60}>{t.descriptionText()}</Text>
              <Text color={Colors.SystemGrey60}>{t.descriptionText2()}</Text>
              <Text color={Colors.SystemGrey60}>{t.descriptionText3()}</Text>
            </StackChildren>
            <div>
              <Stack size={Inset.Sizes.XSmall}>
                <UndecoratedLink
                  to={
                    criticalDeliveryIssues.length === 1
                      ? routes.deliveryIssueDetail.buildPath({
                          id: criticalDeliveryIssues[0].id,
                        })
                      : routes.deliveryIssueList.path
                  }
                >
                  <Button type={Button.Types.PrimaryPill}>
                    {t.buttonText()}
                  </Button>
                </UndecoratedLink>
              </Stack>
              <UndecoratedLink to={routes.deliveryIssuesExplanation.path}>
                <Button type={Button.Types.FlatSecondary}>
                  {t.learnMore()}
                </Button>
              </UndecoratedLink>
            </div>
          </ContentContainer>
        </Container>
      </Inset>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  criticalDeliveryIssues: getCriticalDeliveryIssues(state),
  dasherId: state.dasherId,
})

const mapDispatchToProps = {
  getDeliveryIssuesList: actions.getDeliveryIssuesList,
}

export default connect(mapStateToProps, mapDispatchToProps)(Takeover)
